/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios'
axios.defaults.withCredentials = true
import { cacheAdapterEnhancer } from 'axios-extensions'
import { API_URL } from '@/config/config'
import { EVENTS, EventBus } from '@/services/events/EventBus'

const API_VERSION = '1.0'

const CancelToken = axios.CancelToken

const cancels = []

export default class HttpBaseService {
  API_URL = API_URL
  API_VERSION = API_VERSION

  lastRequestResponseHeaders = {}

  constructor (secure = true, cache = false) {
    if (this.constructor === HttpBaseService) {
      throw new TypeError('Cannot construct Abstract instances directly')
    }
    this.secure = secure
    this.cache = cache
  }

  executeRequest (url, method, data, overrideSecure = false) {
    const http = axios.create({
      adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false }),
    })

    let options = {
      headers: {
        'Accept': `application/${this.API_VERSION}+json`,
        'Content-Type': 'application/json'
      },
      method: method,
      cache: this.cache,
      responseType: 'json',
      cancelToken: new CancelToken (function executor (c) {
        cancels.push(c)
      })
    }



    if (data) {
      options.data = JSON.stringify(data)
    }

    axios.interceptors.response.use(response => {
      return response
    }, error => {
      if (error.response.status === 401) {
        console.log('EVENTS.UnauthenticatedRequest: ', EVENTS.UnauthenticatedRequest)
        EventBus.$emit(EVENTS.UnauthenticatedRequest)
      }
    })
    return http({ ...options, url: this._getUrl(url) })
      .then(response => {
        if (response.status > 199 && response.status < 300) {
          return response.data
        }
        this.checkAuthResponse(response.status)

        // eslint-disable-next-line
        return Promise.reject({
          status: response.status,
          statusText: response.statusText,
          data: response.data
        })
      })
      .catch(thrown => {
        if (axios.isCancel(thrown)) {
          return Promise.reject({
            statusText: 'Client closed request'
          })
        } else {
          const error = thrown
          if (error.response && error.response.status) {
            this.checkAuthResponse(error.response.status)
          }
          console.log('thrown: ', thrown)
          return Promise.reject({
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data,
            error: error
          })
        }
      })
  }

  cancelRequest () {
    cancels.forEach(cancel => {
      cancel.call()
    })
    return Promise.resolve()
  }

  checkAuthResponse (resonseStatus) {
    if (this.secure && resonseStatus === 401) {
      console.log('EVENTS.UnauthenticatedRequest: ', EVENTS.UnauthenticatedRequest)
      EventBus.$emit(EVENTS.UnauthenticatedRequest)
    }
  }



  _getUrl (url) {
    if (url.indexOf('://') > -1) {
      return url
    }
    return API_URL + url
  }
}
